import { addDays } from 'date-fns/addDays'
import { addMonths } from 'date-fns/addMonths'
import { setDate } from 'date-fns/setDate'
import { isAfter } from 'date-fns/isAfter'

import { TRADE_DAY } from '../constants/rule'
import { calcCommission } from './calcCommission'
import { calcPaymentDate } from './calcPaymentDate'
import { calcPaymentMoney } from './calcPaymentMoney'

function getFirstTradeDate(dateToCalc) {
  const twoMonthLaterDate = addMonths(dateToCalc, 2)
  return setDate(twoMonthLaterDate, TRADE_DAY)
}

function getTradeDate(dateToCalc) {
  const currentTradeDate = setDate(dateToCalc, TRADE_DAY)
  if (isAfter(dateToCalc, currentTradeDate)) {
    const nextMonthDate = addMonths(dateToCalc, 1)
    return setDate(nextMonthDate, TRADE_DAY)
  }
  return setDate(dateToCalc, TRADE_DAY)
}

export function simulate(targetDate, amountMoney, ratePerYear, planCode, courseCode) {
  let loanBalance = amountMoney
  let dateToCalc
  let tradeDate
  let everyPaymentDate = []
  let everyCommissions = []
  let everyPayments = []

  while (loanBalance > 0) {
    if (everyPaymentDate.length === 0) {
      //初回の手数料計算開始日
      dateToCalc = addDays(targetDate, 1) // 翌日
      tradeDate = getFirstTradeDate(targetDate) // 初回約定日
    } else {
      dateToCalc = addDays(tradeDate, 1) // 翌日
      tradeDate = getTradeDate(dateToCalc) // 約定日
    }

    // 支払い日
    const paymentDate = calcPaymentDate(tradeDate)
    everyPaymentDate.push(paymentDate)

    // 手数料
    const commission = calcCommission(loanBalance, dateToCalc, tradeDate, ratePerYear)
    everyCommissions.push(commission)

    // 支払額
    const { paymentMoney, monthlyPayment } = calcPaymentMoney(
      amountMoney,
      loanBalance,
      commission,
      courseCode,
      planCode
    )
    everyPayments.push(paymentMoney)

    // 残金
    loanBalance = loanBalance - monthlyPayment + commission
  }
  return { everyPaymentDate, everyCommissions, everyPayments }
}
